import { Subheader } from '@/components/common/Typography';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { Box } from '@chakra-ui/react';
import { FC } from 'react';
import { useCalendar, useLocale } from 'react-aria';
import { CalendarStateOptions, useCalendarState } from 'react-stately';
import { CalendarButton } from './CalendarButton';
import { CalendarGrid } from './CalendarGrid';
import { createCalendar } from './helpers';

type CalendarProps = Omit<CalendarStateOptions, 'locale' | 'createCalendar'>;

export const Calendar: FC<CalendarProps> = (props) => {
    const { locale } = useLocale();
    const state = useCalendarState({
        ...props,
        locale,
        createCalendar,
    });

    const { calendarProps, prevButtonProps, nextButtonProps, title } =
        useCalendar(props, state);

    return (
        <div {...calendarProps} data-cy="date-picker-calendar">
            <Box display="flex" alignItems="center" paddingBottom="4">
                <CalendarButton {...prevButtonProps}>
                    <ChevronLeftIcon w={6} h={6} />
                </CalendarButton>
                <Subheader flex="1" textAlign="center">
                    {title}
                </Subheader>
                <CalendarButton {...nextButtonProps}>
                    <ChevronRightIcon w={6} h={6} />
                </CalendarButton>
            </Box>
            <CalendarGrid state={state} />
        </div>
    );
};
